<template>
    <v-container class="mt-6 pb-12" style="max-width: 1200px;">
        <div class="mb-6">
            <h1 class="text-h4 font-weight-bold mb-1">{{ greeting }}, {{ firstName }}</h1>
            <p class="text-subtitle-1 grey--text mb-0">Here's where things stand today.</p>
        </div>

        <v-row dense class="mb-6">
            <v-col cols="6" sm="3">
                <v-card outlined class="pa-4 text-center stat-card" :loading="loading">
                    <v-icon color="blue" size="22" class="mb-1">mdi-format-list-bulleted</v-icon>
                    <div class="text-h5 font-weight-bold">{{ stats.todo }}</div>
                    <div class="text-caption text--secondary">To Do</div>
                </v-card>
            </v-col>
            <v-col cols="6" sm="3">
                <v-card outlined class="pa-4 text-center stat-card" :loading="loading">
                    <v-icon color="orange" size="22" class="mb-1">mdi-progress-clock</v-icon>
                    <div class="text-h5 font-weight-bold">{{ stats.inProgress }}</div>
                    <div class="text-caption text--secondary">In Progress</div>
                </v-card>
            </v-col>
            <v-col cols="6" sm="3">
                <v-card outlined class="pa-4 text-center stat-card" :loading="loading">
                    <v-icon color="error" size="22" class="mb-1">mdi-alert-circle</v-icon>
                    <div class="text-h5 font-weight-bold">{{ stats.overdue }}</div>
                    <div class="text-caption text--secondary">Overdue</div>
                </v-card>
            </v-col>
            <v-col cols="6" sm="3">
                <v-card outlined class="pa-4 text-center stat-card" :loading="loading">
                    <v-icon color="success" size="22" class="mb-1">mdi-check-circle</v-icon>
                    <div class="text-h5 font-weight-bold">{{ stats.completed }}</div>
                    <div class="text-caption text--secondary">Completed</div>
                </v-card>
            </v-col>
        </v-row>

        <h2 class="text-h6 font-weight-bold mb-3">Jump back in</h2>
        <v-row dense class="mb-6">
            <v-col cols="12" sm="4">
                <v-card outlined hover class="pa-4 quick-link-card" @click="goToMyWork(0, 'tasks')">
                    <v-icon color="primary" size="28" class="mb-2">mdi-format-list-checks</v-icon>
                    <div class="font-weight-bold">My Tasks</div>
                    <div class="text-caption text--secondary">What you need to work on</div>
                </v-card>
            </v-col>
            <v-col cols="12" sm="4">
                <v-card outlined hover class="pa-4 quick-link-card" @click="goToMyWork(1, 'tasks')">
                    <v-icon color="primary" size="28" class="mb-2">mdi-account-arrow-right</v-icon>
                    <div class="font-weight-bold">Assigned by Me</div>
                    <div class="text-caption text--secondary">Tasks you've delegated</div>
                </v-card>
            </v-col>
            <v-col cols="12" sm="4">
                <v-card outlined hover class="pa-4 quick-link-card" @click="$router.push('/calendar')">
                    <v-icon color="primary" size="28" class="mb-2">mdi-calendar-clock</v-icon>
                    <div class="font-weight-bold">Calendar</div>
                    <div class="text-caption text--secondary">See your scheduled work</div>
                </v-card>
            </v-col>
        </v-row>

        <v-alert dense text color="grey darken-1" icon="mdi-information-outline" class="mb-0">
            Productivity trends, time logged, and team insights are coming to Home in a future update.
        </v-alert>
    </v-container>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'HomeComponent',
    inject: ['myTaskStats', 'refreshMyTaskStats', 'isLoadingMyTaskStats'],
    computed: {
        ...mapGetters({ get_user: 'auth/get_user' }),
        firstName() {
            return this.get_user && this.get_user.name ? this.get_user.name.split(' ')[0] : '';
        },
        greeting() {
            const hour = new Date().getHours();
            if (hour < 12) return 'Good morning';
            if (hour < 18) return 'Good afternoon';
            return 'Good evening';
        },
        loading() {
            return this.isLoadingMyTaskStats ? this.isLoadingMyTaskStats() : false;
        },
        stats() {
            const s = this.myTaskStats ? this.myTaskStats() : {};
            return {
                todo: s.todo_tasks || 0,
                inProgress: s.in_progress_tasks || 0,
                overdue: s.overdue_tasks || 0,
                completed: s.completed_tasks || 0,
            };
        },
    },
    mounted() {
        document.title = 'DG Tasks - Home';
        if (typeof this.refreshMyTaskStats === 'function') {
            this.refreshMyTaskStats();
        }
    },
    methods: {
        goToMyWork(tab, view) {
            this.$router.push({ path: '/dashboard', query: { tab: String(tab), view } });
        },
    },
};
</script>

<style scoped>
.stat-card {
    border-radius: 10px;
}

.quick-link-card {
    border-radius: 10px;
    cursor: pointer;
    transition: box-shadow 0.15s ease, transform 0.15s ease;
}

.quick-link-card:hover {
    transform: translateY(-1px);
}
</style>
